import * as React from "react";
import { useEffect, useState } from "react";
import { getSession, updateSession } from "../../libs/user";
import Modal from "../core/Modal";
import { jfetch } from "../../utils";
import Button from "../core/Button";


function Poll(props) {
  const [show, setShow] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(3);
  const [voted, setVoted] = useState(false)
  const [results, setResults] = useState([])

  useEffect(() => {
    getSession().then(data => {
      if (!data.session.viewed_beta_popup) {
        setShow(true);
        setTimeout(() => setTimeRemaining(2), 1000);
        setTimeout(() => setTimeRemaining(1), 2000);
        setTimeout(() => setTimeRemaining(0), 3000);
      }
    });  
  }, []);

  function vote(choice_id){
    jfetch.post('/poll/answers', {poll_answer: {
      question_id: props.poll.id,
      choice_id: choice_id
    }})
    .then((res) => {
      setResults(res.vote_results)
      setVoted(true)
    })
  }
  return (
    <Modal
      title="CORE Poll"
      open={show}
      submittable={false}
      closeText={`Continue ${timeRemaining > 0 ? `(${timeRemaining})` : ""}`}
      canClose={timeRemaining < 1}
      disallowClickOutside={true}
      close={() => setShow(false)}
      onClose={() => updateSession({ viewed_beta_popup: true })}
      hideCloseX={true}
    >
    
      {!voted && (
        <>
        <div style={{textAlign:'left', marginTop:'20px', marginBottom:'15px'}}>
          <h4><strong>{props.poll.info}</strong></h4>
        </div>
        <div> 
          {props.choices.map((choice) => {
            return (
              <div key={choice.id} className="poll-choice-div" style={{padding: '8px 0px'}}>
                <button className="btn btn-info" onClick={() => vote(choice.id)}>
                  {choice.info}
                </button>
              </div>
            )
          })}
        </div>
        </>
      )}
      {voted && (
        <>
        <div style={{textAlign:'left', marginTop:'20px', marginBottom:'15px'}}>
          <h4><strong>Results</strong></h4>
        </div>
        <div> 
          {results.map((result,i) => {
            return (
              <div key={`${result}-${i}`} className="poll-result-div" style={{padding: '8px 0px'}}>
                <div>
                  {result.name}: {result.percent}
                </div>
              </div>
            )
          })}
        </div>            
        </>
      )}      
    </Modal>
  );
}

export default Poll;



// WEBPACK FOOTER //
// ./app/javascript/components/home/Poll.tsx